export const deviceFieldKeysMap = new Map([
    ['name', 'Name'],
    ['_id', 'MAC'],
    ['id', 'Mac Address'],
    ['type', 'Type'],
    ['last_fw_update', 'Last update'],
    ['firmware', 'Firmware'],
    ['hw_version', 'Hardware'],
]);
